/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetBilling404Response
 */
export interface GetBilling404Response {
    /**
     * 
     * @type {string}
     * @memberof GetBilling404Response
     */
    message?: string;
}


/**
 * Check if a given object implements the GetBilling404Response interface.
 */
export function instanceOfGetBilling404Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function GetBilling404ResponseFromJSON(json: any): GetBilling404Response {
    return GetBilling404ResponseFromJSONTyped(json, false);
}

export function GetBilling404ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBilling404Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function GetBilling404ResponseToJSON(value?: GetBilling404Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

